import $ from 'jquery';

export const injectMagicEraserCanvasHtml = () => {
  $('#magic-eraser-container').html(`
    <canvas id="drawing-magic-eraser-canvas"></canvas>
    <canvas id="manipulation-magic-eraser-canvas" style="display: none"></canvas>`);
};
